// extracted by mini-css-extract-plugin
export var component = "HeaderLogo-module--component--Gz0Ie";
export var link = "HeaderLogo-module--link--dGQjR";